// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__GjsEg","static":"tooltip_static__T19rS","icon":"tooltip_icon__nc-Ge","box":"tooltip_box__QXVgv"};